<template>
  <el-popover
  placement="top"
  width="900"
  :open-delay="200"
  trigger="hover">
  <div class="detalis-view">
    <div>退款明细</div>
    <div class="refund-detail-view">
      <div class="refund-row">
        <div class="refund-col" v-for="(item, idx) of equationOneStrs" :key="idx">
          <span>{{ item }}</span>
          <span>{{ equationOnes[idx] }}</span>
        </div>
      </div>
      <div class="refund-row">
        <div class="refund-col" v-for="(item, idx) of equationTwoStrs" :key="idx">
          <span>{{ item }}</span>
          <span>{{ equationTwos[idx] }}</span>
        </div>
      </div>
    </div>
  </div>
  <i class="el-icon-question question" slot="reference" @mouseenter="getRefundAmountDetails"></i>
</el-popover>
</template>
<script type="text/ecmascript-6">

export default {
  data() {
    return {
      equationOneStrs: [],
      equationOnes: [],
      equationTwoStrs: [],
      equationTwos: []
    }
  },
  methods: {
    // 按钮点击获取数据
    getRefundAmountDetails() {
      this.equationOneStrs = []
      this.equationOnes = []
      this.equationTwoStrs = []
      this.equationTwos = []
      this.$emit('getRefundAmountDetails')
    },
    // 返回的数据
    handleData(data) {
      this.equationOneStrs = data.equationOneStrs || []
      this.equationOnes = data.equationOnes || []
      this.equationTwoStrs = data.equationTwoStrs || []
      this.equationTwos = data.equationTwos || []
    }
  }
}
</script>
<style lang="less" scoped>
.detalis-view{
  padding:10px 10px;
  overflow-x: auto;
}
.question{
  font-size:18px;
  vertical-align: middle;
  margin:0 2px;
  cursor: pointer;
}
.refund-detail-view {
  .refund-row {
    display: flex;
    .refund-col {
      display: flex;
      flex-direction: column;
      align-items: center;
      white-space: nowrap;
      span{
        font-size: 12px;
        padding: 4px 0;
      }
    }
  }
}
</style>
